/**
 * This simple type specifies the manner in which a path should be filled. The lightening and darkening of a path
 * allow for certain parts of the shape to be colored lighter of darker depending on user preference.
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.10.37
 */
export enum PathFillMode {
    /**
     * Darken Path Fill
     * This specifies that the corresponding path should have
     * a darker shaded color applied to it’s fill.
     */
    darken = "darken",

    /**
     * Darken Path Fill Less
     * This specifies that the corresponding path should have
     * a slightly darker shaded color applied to it’s fill.
     */
    darkenLess = "darkenLess",

    /**
     * Lighten Path Fill
     * This specifies that the corresponding path should have
     * a lightly shaded color applied to it’s fill.
     */
    lighten = "lighten",

    /**
     * Lighten Path Fill Less
     * This specifies that the corresponding path should have
     * a slightly lighter shaded color applied to it’s fill.
     */
    lightenLess = "lightenLess",

    /**
     * No Path Fill
     * This specifies that the corresponding path should have
     * no fill.
     */
    none = "none",

    /**
     * Normal Path Fill
     * This specifies that the corresponding path should have
     * a normally shaded color applied to it’s fill.
     */
    norm = "norm",
}
